import firebase from "firebase/app";
import "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDMyaTL5fluMpyCQ6kA7Ozl5Os78hbUirs",
  authDomain: "msuanblogs.firebaseapp.com",
  projectId: "msuanblogs",
  storageBucket: "msuanblogs.appspot.com",
  messagingSenderId: "61237547926",
  appId: "1:61237547926:web:3d7ec9e8826e894bb683b7"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const timestamp = firebase.firestore.FieldValue.serverTimestamp;

export {timestamp};
export default firebaseApp.firestore();